import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ITenderAdd } from '../../interfaces/dtos/IPreTenderAdd';
import { ISellableTenders } from '../../interfaces/dtos/ISellableTenders';
import { ITender } from '../../interfaces/dtos/ITender';
import { ITenderGroup } from '../../interfaces/dtos/ITenderGroup';
import { ITenderMenuState } from '../../interfaces/states/ITenderMenuState';

const initialState: ITenderMenuState = {
  sellableTenders: {
    tenderGroups: [],
    rawTenders: [],
  },
  selectedTenderGroup: {
    tenders: [],
  },
  selectedTender: undefined,
};

class TenderMenuReducer extends ImmerReducer<ITenderMenuState> {
  public updateTender(selectedTender: ITender): void {
    this.setSelectedTender(selectedTender);
  }
  public setTenders(tenders: ITender[]): void {
    this.draftState.sellableTenders.rawTenders = tenders;
  }

  public setTenderGroups(tenderGroups: ITenderGroup[]): void {
    this.draftState.sellableTenders.tenderGroups = tenderGroups;
  }

  public setTenderMenu(sellableTenders: ISellableTenders): void {
    this.draftState.sellableTenders = sellableTenders;
  }

  public setSelectedTenderGroup(name?: string): void {
    if (name && this.draftState.sellableTenders.tenderGroups) {
      const newTenderGroup = this.draftState.sellableTenders.tenderGroups.find(
        (tenderGroup): boolean => tenderGroup.name === name,
      );
      if (newTenderGroup) {
        // Only update the selected tender group if it's not the same one.
        // Remove the selected tender if a new group is selected.
        const selectedTenderGroup = this.draftState.selectedTenderGroup;
        if (
          selectedTenderGroup === undefined ||
          selectedTenderGroup?.name !== newTenderGroup.name
        ) {
          this.draftState.selectedTenderGroup = newTenderGroup;
          this.draftState.selectedTender = undefined;
        }
      }
    }
  }

  public setSelectedTender(tender?: ITender): void {
    this.draftState.selectedTender = tender;
  }

  public setSelectedTenderById(selectedTenderId: string): void {
    const selectedTender = this.getTenderById(selectedTenderId);
    this.setSelectedTender(selectedTender);
  }

  public setSuggestedTenderAmount(suggestedAmounts: number[]): void {
    if (this.draftState.selectedTender) {
      this.draftState.selectedTender.suggestedAmounts = suggestedAmounts;
    }
  }

  public setUnPaidPreTender(preTender: ITenderAdd): void {
    this.draftState.unPaidPreTender = preTender;
  }

  public clearUnPaidPreTender(): void {
    this.draftState.unPaidPreTender = undefined;
  }

  public getTenderById = (id: string): ITender | undefined => {
    const tender = this.draftState.sellableTenders.rawTenders.find(
      (tender): boolean => tender.id === id,
    ) as ITender | undefined;
    return tender;
  };
}

export const TenderMenuActions = createActionCreators(TenderMenuReducer);
export const TenderMenuReducerFunction = createReducerFunction(TenderMenuReducer, initialState);
